function initScrollAnimations(options) {
  console.log('initScrollAnimations');
  options = options || {};
  var threshold = options.threshold || 0.15;
  var selector = '[data-animate], [data-animate-stagger], .u-fade-up, .u-fade-left, .u-fade-right, .u-fade-in';
  var rootMargin = options.rootMargin || '0px 0px -40px 0px';

  // Bail out entirely if reduced motion is preferred
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll(selector).forEach(function(el) {
      // Respect any explicit delay even when we skip scroll-triggered animation
      var delayAttr = el.getAttribute('data-animate-delay');
      if (delayAttr) {
        var delayMs = parseInt(delayAttr, 10);
        if (!isNaN(delayMs)) {
          el.style.transitionDelay = delayMs + 'ms';
          setTimeout(function() {
            el.style.transitionDelay = '';
          }, delayMs + 700);
        }
      }
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var el = entry.target;

        // If element has data-animate-delay (e.g. "100", "200"), apply it
        var delayAttr = el.getAttribute('data-animate-delay');
        if (delayAttr) {
          var delayMs = parseInt(delayAttr, 10);
          if (!isNaN(delayMs)) {
            el.style.transitionDelay = delayMs + 'ms';
            // Only the entrance waits: once it's over (the longest is 0.6s), drop
            // the delay, or every later transition on the element, such as a
            // button's hover, would wait for it too.
            setTimeout(function() {
              el.style.transitionDelay = '';
            }, delayMs + 700);
          }
        }
        el.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: threshold, rootMargin: rootMargin });

  document.querySelectorAll(selector).forEach(function(el) {
    observer.observe(el);
  });
}

function initAccordionScrollMobile() {
  var MOBILE_BREAKPOINT = 1024;

  document.addEventListener('click', function(e) {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;

    var toggle = e.target.closest('.wp-block-accordion-heading__toggle');
    if (!toggle) return;

    var item = toggle.closest('.wp-block-accordion-item');
    if (!item) return;

    // The Interactivity API toggles is-open before this listener fires,
    // so is-open being present means the item just opened.
    var isNowOpen = item.classList.contains('is-open');
    if (!isNowOpen) return;

    // Wait for the Interactivity API to apply the is-open class and for any CSS transition
    setTimeout(function() {
      var top = item.getBoundingClientRect().top + window.pageYOffset;
      var header = document.querySelector('.site-header');
      var offset = header ? header.offsetHeight : 0;
      window.scrollTo({ top: top - offset - 16, behavior: 'smooth' });
    }, 50);
  });
}

function initStickyHeader() {
  var header = document.querySelector('.site-header');
  if (!header) return;

  window.addEventListener('scroll', function() {
    if (window.scrollY > 60) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }, { passive: true });
}